import React from 'react';
import { Box, useTheme } from '@mui/material';

interface WatchlistsIconProps {
  size?: number;
  variant?: 'auto' | 'dark' | 'light';
}

const WatchlistsIcon: React.FC<WatchlistsIconProps> = ({ 
  size = 16, 
  variant = 'auto' 
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  
  // Determine which variant to use
  const useVariant = variant === 'auto' ? (isDark ? 'dark' : 'light') : variant;
  
  // Get the appropriate SVG path
  const svgPath = `/assets/Icons/Watchlists_icon_Theme=${useVariant}.svg`;
  
  return (
    <Box
      component="img"
      src={svgPath}
      alt="Watchlists"
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        display: 'block',
      }}
    />
  );
};

export default WatchlistsIcon; 